export default __webpack_public_path__ + "static/media/latest-news-img25.dd9722ff.jpg";